import { History } from "history";

import { PageType } from "../../constants";
import { Programs } from "../../models/programsConfig";
import { ProgramsDataResponse } from "../../server/crm/api/models/forms";
import { FormsScope } from "../scopes";
import { createOnboardingAction, createOnboardingAsyncAction } from "./helpers/actionCreators";

export enum CrmIdXboxActions {
  FETCH_STATUS_UPDATES = "@crmApi/FETCH_STATUS_UPDATES",
  FETCH_DATA_PARTNER_CENTER_ENROLLMENT_POLLING_START = "@crmApi/FETCH_DATA_PARTNER_CENTER_ENROLLMENT_POLLING_START",
  FETCH_DATA_PARTNER_CENTER_ENROLLMENT_POLLING_COMPLETED = "@crmApi/FETCH_DATA_PARTNER_CENTER_ENROLLMENT_POLLING_COMPLETED",
  FETCH_DATA_PARTNER_CENTER_ENROLLMENT_POLLING_ERROR = "@crmApi/FETCH_DATA_PARTNER_CENTER_ENROLLMENT_POLLING_ERROR",
}

export enum CrmActions {
  FETCH_CRM_DATA_START = "@crmApi/FETCH_CRM_DATA_START",
  FETCH_CRM_DATA_COMPLETED = "@crmApi/FETCH_CRM_DATA_COMPLETED",
  FETCH_CRM_DATA_ERROR = "@crmApi/FETCH_CRM_DATA_ERROR",
  SAVE_CRM_DATA_START = "@crmApi/SAVE_CRM_DATA_START",
  SAVE_CRM_DATA_COMPLETED = "@crmApi/SAVE_CRM_DATA_COMPLETED",
  SAVE_CRM_DATA_ERROR = "@crmApi/SAVE_CRM_DATA_ERROR",
  SUBMIT_CRM_DATA_START = "@crmApi/SUBMIT_CRM_DATA_START",
  SUBMIT_CRM_DATA_COMPLETED = "@crmApi/SUBMIT_CRM_DATA_COMPLETED",
  SUBMIT_CRM_DATA_ERROR = "@crmApi/SUBMIT_CRM_DATA_ERROR",
  DELETE_GAME_CONCEPT_START = "@crmApi/DELETE_GAME_CONCEPT_START",
  DELETE_GAME_CONCEPT_COMPLETED = "@crmApi/DELETE_GAME_CONCEPT_COMPLETED",
  DELETE_GAME_CONCEPT_ERROR = "@crmApi/DELETE_GAME_CONCEPT_ERROR",
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const crmIdXboxActions: any = {
  fetchIdXboxStatusUpdates: createOnboardingAction(
    CrmIdXboxActions.FETCH_STATUS_UPDATES,
    FormsScope,
    (history: History) => ({ history })
  ),
  fetchDataForPartnerCenterEnrollmentPolling: createOnboardingAsyncAction(
    FormsScope,
    CrmIdXboxActions.FETCH_DATA_PARTNER_CENTER_ENROLLMENT_POLLING_START,
    () => ({}),
    CrmIdXboxActions.FETCH_DATA_PARTNER_CENTER_ENROLLMENT_POLLING_COMPLETED,
    () => ({}),
    CrmIdXboxActions.FETCH_DATA_PARTNER_CENTER_ENROLLMENT_POLLING_ERROR,
    (error: Error) => ({ error })
  ),
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const crmActions: any = {
  fetchCrmData: createOnboardingAsyncAction(
    FormsScope,
    CrmActions.FETCH_CRM_DATA_START,
    (pageType: PageType | undefined, program: Programs, gameConceptId: string | undefined) => ({
      pageType,
      program,
      gameConceptId,
    }),
    CrmActions.FETCH_CRM_DATA_COMPLETED,
    (data: ProgramsDataResponse) => ({
      data,
    }),
    CrmActions.FETCH_CRM_DATA_ERROR,
    (error: Error) => ({ error })
  ),
  saveCrmData: createOnboardingAsyncAction(
    FormsScope,
    CrmActions.SAVE_CRM_DATA_START,
    (program: Programs, formId: string, subFormId: string, conceptId: string | undefined) => ({
      program,
      formId,
      subFormId,
      conceptId,
    }),
    CrmActions.SAVE_CRM_DATA_COMPLETED,
    (data: ProgramsDataResponse) => ({
      data,
    }),
    CrmActions.SAVE_CRM_DATA_ERROR,
    (error: Error) => ({ error })
  ),
  submitCrmData: createOnboardingAsyncAction(
    FormsScope,
    CrmActions.SUBMIT_CRM_DATA_START,
    (program: Programs, formId: string, conceptId: string | undefined) => ({
      program,
      formId,
      conceptId,
    }),
    CrmActions.SUBMIT_CRM_DATA_COMPLETED,
    (data: ProgramsDataResponse) => ({
      data,
    }),
    CrmActions.SUBMIT_CRM_DATA_ERROR,
    (error: Error) => ({ error })
  ),
  deleteCrmGameConcept: createOnboardingAsyncAction(
    FormsScope,
    CrmActions.DELETE_GAME_CONCEPT_START,
    (program: Programs, gameConceptId: string) => ({
      program,
      gameConceptId,
    }),
    CrmActions.DELETE_GAME_CONCEPT_COMPLETED,
    () => ({}),
    CrmActions.DELETE_GAME_CONCEPT_ERROR,
    (error: Error) => ({ error })
  ),
};
